<div class="accordion-panel" [class.opened]="opened">
  <div class="accordion-title-container">
    <a href="#" class="accordion-button" (click)="toToggle($event)">
      <ng-content select=".accordion-title"></ng-content>
    </a>
    <ng-content select=".accordion-header"></ng-content>
    <i class="icon icon-arrow_down" (click)="toToggle($event)" (keydown.enter)="toToggle($event)" tabindex="0" role="button"></i>
  </div>
  <div class="accordion-body" [ngClass]="{ hidden: !opened }">
    <ng-content></ng-content>
  </div>
</div>
